/************* NAME OF ROUTES ********************* */
/* -------------- AMBASSADOR ROUTES ----------------- */
// Login
export const NAVIGATE_TO_LOGINPAGE = "/login";
export const NAVIGATE_TO_FORGETPASSWORD = "/forget-password";

// Dashboard
export const NAVIGATE_TO_DASHBOARD = "/";

// Partners
export const NAVIGATE_TO_PARTNERSPAGE = "/patners";
export const NAVIGATE_TO_PARTNERVIEWPAGE = "/partner-view";
export const NAVIGATE_TO_PARTNERAGENTS = "/partner-agents";

// Merchants
export const NAVIGATE_TO_MERCHANTSPAGE = "/merchants";
export const NAVIGATE_TO_MERCHANTVIEWPAGE = "/merchant-view";
export const NAVIGATE_TO_MERCHANTTRANSACTIONSPAGE = "/merchant-transactions";
export const NAVIGATE_TO_MERCHANTTRANSACTIONDETAILSPAGE =
  "/merchant-transaction-details";

// Staffs
export const NAVIGATE_TO_STAFFPAGE = "/partner-staffs";
export const NAVIGATE_TO_STAFFVIEWPAGE = "/partner-staff-view";

// Agents
export const NAVIGATE_TO_AGENTSPAGE = "/agents";
export const NAVIGATE_TO_AGENTVIEWPAGE = "/agent-view";
export const NAVIGATE_TO_AGENTBANKDETAILSPAGE = "/agent-bank-details";
export const NAVIGATE_TO_AGENTCOMMISSIONSPAGE = "/agent-commissions";

// Agent Staff
export const NAVIGATE_TO_AGENTSTAFFPAGE = "/agent-staffs";
export const NAVIGATE_TO_AGENTSTAFFVIEWPAGE = "/agent-staff-view";

// Accounts
export const NAVIGATE_TO_ACCOUNTSPAGE = "/accounts";
export const NAVIGATE_TO_ACCOUNTVIEWPAGE = "/account-view";

// Integration
export const NAVIGATE_TO_APIACCESSPAGE = "/api-access";
export const NAVIGATE_TO_APIUSAGEPAGE = "/api-usage";
export const NAVIGATE_TO_LOGSPAGE = "/logs";
export const NAVIGATE_TO_APIACCESSVIEWPAGE = "/api-access-view";
export const NAVIGATE_TO_PARTNERPROPERTIESPAGE = "/api-partner-properties";
export const NAVIGATE_TO_VIEWLOGGEDINAPIDETAILSPAGE =
  "/api-view-logged-in-api-details";

//Transactions
export const NAVIGATE_TO_TRANSACTIONPAGE = "/transactions";
export const NAVIGATE_TO_TRANSACTIONDETAILSPAGE = "/transaction-details";

//Tarrifs
export const NAVIGATE_TO_TARRIFPAGE = "/tarrifs";

//Profile
export const NAVIGATE_TO_PROFILEPAGE = "/profile";

//Support
export const NAVIGATE_TO_INFOPAGE = "/info";
export const NAVIGATE_TO_NOTIFICATIONPAGE = "/notification";

// logs
export const NAVIGATE_TO_LIST_LOGS = "/list-logs";
export const NAVIGATE_TO_LIST_FOLDER_LOGS = "/list-folder-logs";

// Error Pages
export const ERROR_404_PAGE = "*";
export const NAVIGATE_TO_MERCHANTPROPERTIESPAGE = "/api-merchant-properties";
